/**
 * Whether a modal dialog is showing, so Escape belongs to it. Mobile flyout
 * drawers stay mounted (`v-show`) with `aria-modal`, so hidden ones don't
 * count.
 */
export function modalDialogOpen(): boolean {
  return [
    ...document.querySelectorAll<HTMLElement>(
      '[role="dialog"][aria-modal="true"]',
    ),
  ].some((dialog) => dialog.checkVisibility());
}
